import React, { useEffect, useRef, useState } from "react";
import * as Yup from "yup";
import "./profile.css";
import { SnackbarUI, useSnackbar } from "../header/snackbarProvider";
import { getUserInfo, submitPersonalInfoUpdate, UserDto } from "../../services/profile.service";
import { City, Country, State } from "country-state-city";
import { format, parse } from "date-fns";
import { ErrorMessage, Field, Form, Formik } from "formik";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import SelectPicker from "../selectpicker/selectPicker";
import ConfirmationDialog from "../header/confirmation.dialog";

const personalInfoValidationSchema = Yup.object({
    organization: Yup.string().required("Organization is required"),
    dateOfBirth: Yup.date()
    .required("Date of Birth is required"),
    gender: Yup.string().required("Gender is required"),
    country: Yup.string().required("Country is required"),
    state: Yup.string().required("State is required"),
    city: Yup.string().required("City is required"),
    //addressType: Yup.string().required("Address type is required"),
    address1: Yup.string()
      .required("Address 1 is required")
      .max(250, "Address 1 must be at most 250 characters"),
    address2: Yup.string().max(250, "Address 2 must be at most 250 characters"), // Optional field
    postalCode: Yup.string().required("Postal Code is required"),
  });
  
  const genderOptions = [
    { value: "Female", label: "Female" },
    { value: "Male", label: "Male" },
    { value: "Other", label: "Other" },
  ];
  
  


const PersonalInfoComponent = () => {

  const { showSnackbar, snackbar } = useSnackbar();
  const [usePersonalInfo, setUserPersonalInfo] = useState("");
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [openPersConfirmationDialog, setOpenPersConfirmationDialog] = useState(false);
  const [dialogValues, setDialogValues] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [showLoadingModal, setShowLoadingModal] = useState(false);

   //Using explit mode states for preview and update for clarity
   const [isPreviewMode, setIsPreviewMode] = useState(false);
   const [isUpdateMode, setIsUpdateMode] = useState(false);



  
  
  const handlePersDialogClose = () => {
    setOpenPersConfirmationDialog(false);
    setIsSubmitting(false); // Re-enable submit button
  };

    const [initialValuesOfProfileInfo, setInitialValuesOfProfileInfo] = useState({
      name: "",
      emailId: "",
      mobileNo: "",
      organization: "",
      dateOfBirth: "",
      gender: "",
      country: "",
      state: "",
      city: "",
      //addressType: "Work",
      address1: "",
      address2: "",
      postalCode: "",
    });
    

    useEffect(() => {
        const fetchData = async () => {
          try {
            const userInfoDetails = await getUserInfo();
            if (userInfoDetails && userInfoDetails.length > 0) {
              const userInfo = userInfoDetails[0]; // Access the first object
              setUserPersonalInfo(userInfo);
      
              setInitialValuesOfProfileInfo({
                name: userInfo.name || "",
                emailId: userInfo.email || "",
                mobileNo: userInfo.phone || "",
                organization: userInfo.organizationName || "",
                dateOfBirth: userInfo.dob || "",
                gender: userInfo.gender || "",
                country: userInfo.country || "",
                state: userInfo.state || "",
                city: userInfo.city || "",
                address1: userInfo.permanentAddress || "",
                address2: userInfo.currentAddress || "",
                postalCode: userInfo.pincode || "",
              });

              if (userInfo.organizationName && userInfo.organizationName.trim() !== "") {
                // Show preview if data exists
                setIsPreviewMode(true);
                setIsUpdateMode(false);
              } else {
                // No data exists, show form directly
                setIsPreviewMode(false);
                setIsUpdateMode(false);
              }
    
            } else {
              console.warn("No user data found");
            }
          } catch (error) {
            console.error("Error fetching personal-info details:", error);
          }
        };
      
        fetchData();
      }, []); 
      
      // Populate countries on mount
      useEffect(() => {
        setCountries(
          Country.getAllCountries().map((c) => ({
            value: c.isoCode,
            label: c.name,
          }))
        );
      }, []);

      
      // Populate states when country changes
      useEffect(() => {
        if (initialValuesOfProfileInfo.country) {
          const updatedStates = State.getStatesOfCountry(initialValuesOfProfileInfo.country).map(
            (s) => ({
              value: s.isoCode,
              label: s.name,
            })
          );
          setStates(updatedStates);
        }
      }, [initialValuesOfProfileInfo.country]);

      
      // Populate cities when state changes
      useEffect(() => {
        if (initialValuesOfProfileInfo.country && initialValuesOfProfileInfo.state) {
          const updatedCities = City.getCitiesOfState(
            initialValuesOfProfileInfo.country,
            initialValuesOfProfileInfo.state
          ).map((city) => ({
            value: city.name,
            label: city.name,
          }));
          setCities(updatedCities);
        }
      }, [initialValuesOfProfileInfo.country, initialValuesOfProfileInfo.state]);
    


 const handlePersonalInfoSubmit = async (values, { setSubmitting, validateForm }) => {

   const errors = await validateForm();

   if (Object.keys(errors).length > 0) {
      setSubmitting(false);
      return;
    }
     setIsSubmitting(true);
     setOpenPersConfirmationDialog(true);
     setDialogValues(values);
 };
    
    
  const handlePersonalInfoDialogConfirm = async () => {
        setOpenPersConfirmationDialog(false);
        
     if (isSubmitting) {
         setIsLoading(true);
         setShowLoadingModal(true); // Show loading popup
    
            const userInfoDto = new UserDto(
                dialogValues.name,
                dialogValues.emailId,
                dialogValues.mobileNo,
                dialogValues.organization,
                dialogValues.dateOfBirth,
                dialogValues.gender,
                dialogValues.country,
                dialogValues.state,
                dialogValues.city,
                dialogValues.address1,
                dialogValues.address2,
                dialogValues.postalCode
            );
    
            try {
                const result = await submitPersonalInfoUpdate(userInfoDto);

                if(result){
      
                const userInfoDetails = await getUserInfo();
      
                if (userInfoDetails && userInfoDetails.length > 0) {
                  const userInfo = userInfoDetails[0];
                  setUserPersonalInfo(userInfo);
    
                  setInitialValuesOfProfileInfo({
                    name: userInfo.name || "",
                    emailId: userInfo.email || "",
                    mobileNo: userInfo.phone || "",
                    organization: userInfo.organizationName || "",
                    dateOfBirth: userInfo.dob || "",
                    gender: userInfo.gender || "",
                    country: userInfo.country || "",
                    state: userInfo.state || "",
                    city: userInfo.city || "",
                    address1: userInfo.permanentAddress || "",
                    address2: userInfo.currentAddress || "",
                    postalCode: userInfo.pincode || "",
                  });
                   // After successful submission, show preview
                   setIsPreviewMode(true);
                   setIsUpdateMode(false);

                   window.scrollTo({ top: 0, behavior: 'smooth' });
                  showSnackbar("Personal info updated successfully!", "success");
                }
                
              }else{
                window.scrollTo({ top: 0, behavior: 'smooth' });
                showSnackbar("Personal info update unsuccessful.", "danger");
              }
            
    
            } catch (error) {
                console.error("Error updating personal info:", error);
                 window.scrollTo({ top: 0, behavior: 'smooth' });
                showSnackbar("Personal info update unsuccessful.", "danger");
            } finally {
                setIsLoading(false);
                setShowLoadingModal(false);
                setIsSubmitting(false);
            }
        }
    };
    

    const handleEditClick = () => {
      // Switch to update mode (form with pre-filled data) if edit button is clicked
      setIsPreviewMode(false);
      setIsUpdateMode(true);
    };
      
    



    
    return (
        <>
           <div className="profile-master">

 {/* Render the Snackbar UI here at the top of the page */}
 {snackbar.open && <SnackbarUI message={snackbar.message} type={snackbar.type} />}



 {isPreviewMode && !isUpdateMode ? (
      <div className="profile-content">
      <div className="profile-info-preview">
        <h4>Personal Information</h4>
        <div className="preview-content-container">
          <div className="preview-grid">
            <div className="preview-item">
              <span className="preview-label">Name:</span>
              <span className="preview-value">{usePersonalInfo.name}</span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Email Id:</span>
              <span className="preview-value">{usePersonalInfo.email}</span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Mobile No:</span>
              <span className="preview-value">
                {usePersonalInfo.phone} 
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Organization Name:</span>
              <span className="preview-value">
               {usePersonalInfo.organizationName}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Date Of Birth:</span>
              <span className="preview-value">
              {usePersonalInfo.dob ? format(new Date(usePersonalInfo.dob), 'dd/MM/yyyy') : ''}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Gender:</span>
              <span className="preview-value">
              {usePersonalInfo.gender
                  ? (genderOptions.find(
                 (opt) => opt.value === usePersonalInfo.gender
                 )?.label || "")
               : ""}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Country:</span>
              <span className="preview-value">
              {Country.getCountryByCode(usePersonalInfo.country)?.name ||
                usePersonalInfo.country}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">City:</span>
              <span className="preview-value">
               {usePersonalInfo.city}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">State:</span>
              <span className="preview-value">
              {State.getStateByCodeAndCountry(
                usePersonalInfo.state,
                usePersonalInfo.country
              )?.name || usePersonalInfo.state}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Address 1:</span>
              <span className="preview-value">
               {usePersonalInfo.permanentAddress}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Address 2:</span>
              <span className="preview-value">
               {usePersonalInfo.currentAddress}
              </span>
            </div>
            <div className="preview-item">
              <span className="preview-label">Postal Code:</span>
              <span className="preview-value">
               {usePersonalInfo.pincode}
              </span>
            </div>
          </div>
          <button 
            type="button" 
            className="btn btn-warning mt-4"
            onClick={handleEditClick}
          >
            Edit
          </button>
        </div>
      </div>
    </div>
      ) : (

           <Formik
  initialValues={initialValuesOfProfileInfo}
  enableReinitialize={true}
  validationSchema={personalInfoValidationSchema}
  validateOnBlur={true}  
  validateOnChange={true} 
  onSubmit={handlePersonalInfoSubmit}
>
{({ values, setFieldValue, touched, errors, setFieldTouched, validateField, validateForm }) => {

        return (
    <Form style={{ width: "100%", maxWidth: "100%" }}>
     <div className="profile-content">
      <div className="row">
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="text"  
                id="name" 
                name="name" 
                className="form-control disabled-field" 
                placeholder="Name" 
                // readOnly 
                // disabled  
              />
              <label htmlFor="name">Name<span className="required-input">*</span></label>
            </div>
        </div>
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="text"  
                id="emailId" 
                name="emailId" 
                className="form-control disabled-field" 
                placeholder="emailId" 
                readOnly 
                disabled  
              />
              <label htmlFor="name">Email Id<span className="required-input">*</span></label>
            </div>
          </div>
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="text"  
                id="mobileNo" 
                name="mobileNo" 
                className="form-control disabled-field" 
                placeholder="mobileNo" 
                readOnly 
                disabled  
              />
              <label htmlFor="name">Mobile No<span className="required-input">*</span></label>
            </div>
          </div>
        </div>


        <div className="row">
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="text" 
                id="organization" 
                name="organization" 
                className={`form-control ${touched.organization && errors.organization ? "is-invalid" : ""}`}
                placeholder="Organization Name" 
                maxLength={250} 
                autoComplete="off"
              />
              <label htmlFor="organization">Organization Name<span className="required-input">*</span></label>
              <ErrorMessage name="organization" component="div" className="invalid-feedback" />
            </div>
        </div>
        <div className="col-md-4 mb-3">
             <div className="form-floating">
              <div className="datepicker-container">
               <label htmlFor="dateOfBirth" className="form-label">
                  Date of Birth<span className="required-input">*</span>
               </label>
               <DatePicker
                 id="dateOfBirth"
                 selected={
                  values.dateOfBirth && !isNaN(Date.parse(values.dateOfBirth)) 
                  ? parse(values.dateOfBirth, "yyyy-MM-dd", new Date()) 
                  : null
                }
                 onChange={(date) => {
                    setFieldValue("dateOfBirth", date ? format(date, "yyyy-MM-dd") : "");
                 }}
                 dateFormat="dd/MM/yyyy"
                 placeholderText="Date of Birth"
                 showYearDropdown
                 showMonthDropdown
                 scrollableYearDropdown
                 yearDropdownItemNumber={100}
                 maxDate={new Date()} // Restricts selection to dates in the future or today
                 
                 error={touched.dateOfBirth && errors.dateOfBirth ? errors.dateOfBirth : ""} 
                 touched={touched.dateOfBirth}
                 className={`form-control w-100 ${touched.dateOfBirth && errors.dateOfBirth ? "is-invalid" : ""}`}

                /> 
             
             </div>
             {/* <ErrorMessage name="dateOfBirth" component="div" className="invalid-feedback" /> */}
          </div>
       </div>
        <div className="col-md-4 mb-3">
        <SelectPicker
          key={values.gender}
          name="gender" 
          options={genderOptions}
          value={genderOptions.find((opt) => opt.value === values.gender) || null} 
          handleChange={(selectedOption) => setFieldValue("gender", selectedOption?.value || "")}
          label="Gender"
          required={true}
          error={touched.gender && errors.gender ? errors.gender : ""} 
          touched={touched.gender}
         setFieldTouched={setFieldTouched}
         />
         <ErrorMessage name="gender" component="div" className="invalid-feedback" />
        </div>
        </div>

        {/*country and city depend on dynamic state updates, which might not be triggering Formik’s internal validation refresh properly.*/}
        <div className="row">
                  <div className="col-md-4 mb-3">
                  <SelectPicker
                    name="country" 
                   key={values.country} 
                   options={countries}
                   value={countries.find((c) => c.value === values.country) || ""}
                   handleChange={(selectedOption) => {
                    setFieldValue("country", selectedOption?.value || "");
                    // Force validation after state update to ensure Formik recognizes the change
                     setTimeout(() => {
                          validateField("country");
                      }, 0);
                    
                    // Reset dependent fields
                    const updatedStates = State.getStatesOfCountry(selectedOption?.value).map((s) => ({
                      value: s.isoCode,
                      label: s.name,
                    }));
                    setStates(updatedStates);
                    setCities([]);
                    setFieldValue("state", "");
                    setFieldValue("city", "");
                    
                  
                  }}
                   label="Country/Region"
                   required={true}
                   error={touched.country && errors.country ? errors.country : ""}
                   touched={touched.country}
                   setFieldTouched={setFieldTouched}
                   />
                 <ErrorMessage name="country" component="div" className="invalid-feedback" />
                      
                  </div>
                  <div className="col-md-4 mb-3">
                    <SelectPicker
                    name="state"
                     key={values.state}
                      options={states}
                      value={states.find((s) => s.value === values.state) || ""}
                      handleChange={(selectedOption) => {
                        setFieldValue("state", selectedOption?.value || "");
                           // Force validation after state update to ensure Formik recognizes the change
                             setTimeout(() => {
                                validateField("state");
                             }, 0);
            
                        setCities(City.getCitiesOfState(values.country, selectedOption?.value).map((c) => ({ value: c.name, label: c.name })));
                        setFieldValue("city", "");

                  
                      }}
                      label="State/Province/Territory"
                      required={true}
                      error={touched.state && errors.state ? errors.state : ""}
                      touched={touched.state}
                      setFieldTouched={setFieldTouched}
                    />
                      <ErrorMessage name="state" component="div" className="invalid-feedback" />
                  </div>
                  <div className="col-md-4 mb-3">
                    <SelectPicker
                       name="city"
                       key={values.city}
                      options={cities}
                      value={cities.find((c) => c.value === values.city) || ""}
                      handleChange={(selectedOption) => setFieldValue("city", selectedOption?.value || "")}
                      label="City/Locality"
                      required={true}
                      error={touched.city && errors.city ? errors.city : ""}
                      touched={touched.city}
                      setFieldTouched={setFieldTouched}
                    />
                      <ErrorMessage name="city" component="div" className="invalid-feedback" />
                  </div>
                </div>

  {/* <div className="row my-2">
  <div className="col-md-12 mt-2 mb-3 justify-content-center">
    Address Type<span className="required-input">*</span>&nbsp;&nbsp;
    {[
      { value: "Home", label: "Home" },
      { value: "Work", label: "Work" },
      { value: "University_College", label: "University/College" },
    ].map((option) => (
      <div key={option.value} className="form-check form-check-inline">
        <Field
          type="radio"
          name="addressType"
          value={option.value}
          id={`address-type-${option.value}`}
          className="form-check-input addressTypeRadio"
        />
        <label
          htmlFor={`address-type-${option.value}`}
          className="form-check-label"
        >
          {option.label}
        </label>
      </div>
    ))}
    <ErrorMessage name="addressType" component="div" className="invalid-feedback" />
  </div>
</div> */}

       

        <div className="row">
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="text" 
                id="address1" 
                name="address1" 
                className={`form-control ${touched.address1 && errors.address1 ? "is-invalid" : ""}`}
                placeholder="Address 1" 
                maxLength={250} 
                autoComplete="off"
              />
              <label htmlFor="address1">Address 1<span className="required-input">*</span></label>
              <ErrorMessage name="address1" component="div" className="invalid-feedback" />
            </div>
        </div>
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="text" 
                id="address2" 
                name="address2" 
                className={`form-control ${touched.address2 && errors.address2 ? "is-invalid" : ""}`}
                placeholder="Address 2" 
                maxLength={250} 
                autoComplete="off"
              />
              <label htmlFor="address2">Address 2</label>
              <ErrorMessage name="address2" component="div" className="invalid-feedback" />
            </div>
        </div>
        
        <div className="col-md-4 mb-3">
            <div className="form-floating">
              <Field 
                type="number" 
                id="postalCode" 
                name="postalCode" 
                className={`form-control ${touched.postalCode && errors.postalCode ? "is-invalid" : ""}`}
                placeholder="postal Code" 
                maxLength={12} 
                autoComplete="off"
                onInput={(e) => {
                  // Prevent entering more than 6 digits
                  if (e.target.value.length > 6) {
                    e.target.value = e.target.value.slice(0, 12);
                  }
                }}
              />
              <label htmlFor="postalCode">Postal Code<span className="required-input">*</span></label>
              <ErrorMessage name="postalCode" component="div" className="invalid-feedback" />
            </div>
          </div>

          </div>

        
   </div>
    <div className="btn-div">
        <button type="submit" className={`btn ${isUpdateMode ? "btn edit" : "btn add"}`}>
                  {isUpdateMode ? "Update" : "Submit"}
                </button>
    </div>
    </Form>
 );
}}
</Formik>


)}


<ConfirmationDialog
        open={openPersConfirmationDialog}
        onClose={handlePersDialogClose}
        onConfirm={handlePersonalInfoDialogConfirm}
        title=""
        message="Are you sure to submit?"
      />


           </div>

           {showLoadingModal && (
  <div className="loading-overlay">
    <div className="loading-container">
      <div className="loading-header">Processing...</div>
      <div className="loading-body">
        <div className="spinner-border text-primary loading-spinner" role="status"></div>
        <p className="mt-3">Please wait...</p>
      </div>
    </div>
  </div>
)}
       </>
  )
}
export default PersonalInfoComponent;

